import QaEvent from './qaEvent';
import QaEventProps from './qaEventProps';

class LinkClickPageEvent implements QaEvent {
  public getEvent(props: QaEventProps) {
    return {
      event: props.event,
      pageName: props.pageName,
      clientName: props.clientName,
      category: props.category,
      eventCategory: props.eventCategory,
      eventAction: props.eventAction,
      eventLabel: props.eventLabel,
      accountBrand: props.accountBrand
    };
  }
}

export default LinkClickPageEvent;
